export default __webpack_public_path__ + "static/media/settings.a7ac08f9.svg";